export interface OrgModelQueryScope {
  readonly folderId: string | null | undefined;
  /** Diagram-bound presentation authority; never use this to broaden a folder query. */
  readonly diagramId?: string | null;
  readonly asOf?: string;
  readonly txAt?: string;
  readonly expectedGraphVersion?: number;
  readonly maxRecords?: number;
}

/** Prefix used only for invalidating every declared variant of one folder model. */
export function orgModelQueryPrefix(folderId: string | null | undefined) {
  return ['atlas', 'org-model', folderId] as const;
}

/** Exact key for a permissioned org-model projection. */
export function orgModelQueryKey(scope: OrgModelQueryScope) {
  return [
    ...orgModelQueryPrefix(scope.folderId),
    scope.diagramId,
    scope.asOf,
    scope.expectedGraphVersion,
    scope.maxRecords,
    scope.txAt,
  ] as const;
}

/** Commands reconcile only against the current, unbounded-by-client live projection. */
export function liveOrgModelQueryKey(folderId: string | null | undefined) {
  return orgModelQueryKey({ folderId });
}
